import { Component, computed, OnInit, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseModal } from 'shared/abstract/base-modal';
import { DataGridComponent } from 'shared/components/data-grid/data-grid.component';
import { DataGridColumnDefinition } from 'shared/interfaces/data-grid.interface';

@Component({
    selector: 'app-imports-runner-confirmation-modal',
    templateUrl: './imports-runner-confirmation-modal.component.html',
    styleUrl: './imports-runner-confirmation-modal.component.scss',
    imports: [TranslateModule, DataGridComponent],
})
export class ImportsRunnerConfirmationModalComponent extends BaseModal implements OnInit {
    data: any;
    hasAtLeastOneListingOverwrite = signal<boolean>(false);

    importItemColumns: DataGridColumnDefinition[] = [
        {
            headerLabel: 'exports.imports-runner.labels.channelMappedId',
            dataKey: 'channelMappedId',
        },
        {
            headerLabel: 'listings.table.shijiId',
            dataKey: 'listing.shijiId',
            customCellRendererData: {
                defaultValueIfNull: 'exports.imports-runner.importItems.createNewListingPlaceholder',
            },
        },
    ];

    constructor(private translateService: TranslateService) {
        super();
    }

    ngOnInit(): void {
        this.hasAtLeastOneListingOverwrite.set(!!this.data.data.importItems.find((item: any) => item.listing));
    }
}
